<div
  class="z-50 max-w-2xl rounded-lg bg-[#3B3B3B] p-4 whitespace-pre-line text-white shadow-2xl"
  [innerHTML]="tooltip()"
  [attr.data-testid]="dataTestId()"></div>
